import { useEffect } from "react";

const useLockScrollOnInputFocus = () => {
  useEffect(() => {
    const lockScroll = () => {
      console.log("locked and loaded")
      document.body.style.position = "fixed";
      document.body.style.top = `-${window.scrollY}px`;
      document.body.style.left = "0";
      document.body.style.right = "0";
    };

    const unlockScroll = () => {
      const scrollY = document.body.style.top;
      document.body.style.position = "";
      document.body.style.top = "";
      document.body.style.left = "";
      document.body.style.right = "";
      window.scrollTo(0, parseInt(scrollY || "0") * -1);
    };

    const inputs = document.querySelectorAll("input, textarea");

    inputs.forEach((el) => {
      el.addEventListener("focus", lockScroll);
      el.addEventListener("blur", unlockScroll);

      if (document.activeElement === el) {
        lockScroll();
      }
    });

    return () => {
      inputs.forEach((el) => {
        el.removeEventListener("focus", lockScroll);
        el.removeEventListener("blur", unlockScroll);
      });
    };
  }, []);
}

export default useLockScrollOnInputFocus;
